import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../../app/store'
import fetchAPI from '../../../common/fetchAPI'
import { ExpensePolicyDetailStateClass } from './interfaces/expensePolicyDetailStateClass';
import { sortData } from '../../../common/timeLiveFunction';
const initialState: ExpensePolicyDetailStateClass = {
    isLoading: false,
    status: 'idle',
    expensePolicyDetailList: [],
    selectedRecord: {},
    isReload : false,
    sortOrder: 'asc',
    sortColumn: 'AccountExpenseName',
    search: '',
    pageNo: 1,
    pageSize: 10
}
interface IThunkApi {
    state: {
        expensePolicyDetail: ExpensePolicyDetailStateClass;
    },
}
    export const getAccountExpensePolicyCategoryByCategoryIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'expensePolicyDetail/getAccountExpensePolicyCategoryByCategoryId',
        async (arg, thunkApi) => {
            const {AccountExpensePolicyId, AccountExpensePolicyCategoryId} = arg;
            const response = await fetchAPI('api/v2/ExpensePolicyCategory/GetDataAccountExpensePolicyCategorybyId/' + AccountExpensePolicyId + '/' + AccountExpensePolicyCategoryId, 
            'Get', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

    export const GetDataByAccountExpensePolicyIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'expensePolicyDetail/GetDataByAccountExpensePolicyId',
        async (arg, thunkApi) => {

            const response = await fetchAPI('api/v2/ExpensePolicyCategory/GetPolicyDetails/'+ arg, 'Get', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

    export const UpdateAccountExpensePolicyGeneralLimitAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'expensePolicyDetail/UpdateAccountExpensePolicyGeneralLimit',
        async (arg, thunkApi) => {
            const {AccountExpensePolicyId, PolicyAmountLimit,PolicyRequiredLimit,PolicyDescriptionRequired } = arg;
            const response = await fetchAPI('api/v2/ExpensePolicyCategory/UpdateAccountExpensePolicyGeneralLimit/' + AccountExpensePolicyId,
             'POST',
              { ExpenseAmountLimit: PolicyAmountLimit, ReceiptRequiredLimit: PolicyRequiredLimit, IsDescriptionRequired: PolicyDescriptionRequired }, 
              true,
              'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

    export const UpdateAccountExpensePolicyCategorybyCategoryAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'expensePolicyDetail/UpdateAccountExpensePolicyCategorybyCategory',
        async (arg, thunkApi) => {
            const {AccountExpensePolicyCategoryId,IsOverride,ExpenseAmountLimit,ReceiptRequiredLimit,IsDescriptionRequired,IsDisabledCategory} = arg;
            const response = await fetchAPI('api/v2/ExpensePolicyCategory/UpdateAccountExpensePolicyCategory/' + AccountExpensePolicyCategoryId,
             'POST',
              { IsOverride: IsOverride, ExpenseAmountLimit: ExpenseAmountLimit, ReceiptRequiredLimit: ReceiptRequiredLimit, IsDescriptionRequired: IsDescriptionRequired, IsDisabled: IsDisabledCategory }, 
              true,
              'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )
  
export const expensePolicyDetailSlice = createSlice({
    name: 'expensePolicyDetail',
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {};
        },
        updatePagination: (state, action: PayloadAction<any>) => {
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            state.search = action.payload.search;
        },
        updateSorting: (state, action) => {
            state.sortOrder = action.payload.sortOrder;
            state.sortColumn = action.payload.sortColumn;
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            let tempArray = state.expensePolicyDetailList;
            state.expensePolicyDetailList = sortData(tempArray, action.payload.sortOrder, action.payload.sortColumn);
        }
    },
    extraReducers: (builder) => {
        builder
           
            .addCase(getAccountExpensePolicyCategoryByCategoryIdAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(getAccountExpensePolicyCategoryByCategoryIdAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isLoading = false;
                state.selectedRecord = payload[0];
            })
            .addCase(getAccountExpensePolicyCategoryByCategoryIdAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(GetDataByAccountExpensePolicyIdAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(GetDataByAccountExpensePolicyIdAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isLoading = false;
                state.expensePolicyDetailList = payload.data;
                state.isReload = false;
                state.selectedRecord = payload.data[0];
                
            })
            .addCase(GetDataByAccountExpensePolicyIdAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })     
            .addCase(UpdateAccountExpensePolicyCategorybyCategoryAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(UpdateAccountExpensePolicyCategorybyCategoryAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;

            })
            .addCase(UpdateAccountExpensePolicyCategorybyCategoryAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })
            .addCase(UpdateAccountExpensePolicyGeneralLimitAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(UpdateAccountExpensePolicyGeneralLimitAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;

            })
            .addCase(UpdateAccountExpensePolicyGeneralLimitAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })            
    }
})
export const {
    resetSelectedRecordObjectInState,updatePagination,updateSorting
} = expensePolicyDetailSlice.actions
 export const expensePolicyDetailStateClass = (state: RootState) => state.expensePolicyDetail
 export default expensePolicyDetailSlice.reducer